module.exports = __webpack_public_path__ + "img/adminMan.e1b440de.png";